import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpLoaderComponent } from './core/components/http-loader/http-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [HttpLoaderComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
